import React from 'react';

// Sample Animated Background SVG
const AnimatedBackground = () => (
    <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img className='w-full' src="/static/Gaming-Data-Infrastructure.png" alt="" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent "></div>
  </div>
);

const RootCauseAnalysisCard = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => (
  <div className="bg-[#00000099] rounded-lg p-6 flex flex-col items-center text-center shadow-lg hover:scale-105 transition-transform">
    <div className="text-cyan-400 mb-4">{icon}</div>
    <h3 className="text-white font-semibold !text-[25px]">{title}</h3>
    <p className="text-[#ffffff99] !text-base">{description}</p>
  </div>
);

export const AnalysisSection = () => (
  <section className="relative min-h-screen flex items-center justify-center text-white pb-20">
    <AnimatedBackground />

    <div className="relative z-10 max-w-6xl w-full p-6 flex flex-col items-center">
    <h2 className="text-3xl md:!text-[45px] !font-bold text-center mb-4">
        From analyzation to QA
      </h2>
      <p className="text-center text-white md:!text-base mb-12 px-10 md:px-28 ">
      The final step of QA: Complete environmental transparency that delivers definitive answers, 
turning every bug investigation into a closed case with clear resolution paths.      </p>

<div className="relative rounded-3xl w-11/12 md:w-4/5 border border-cyan-300 flex flex-col justify-center items-center px-10 pb-10">
<div className="absolute inset-0 w-full h-full">
    <img className='w-full h-full object-cover blur-md scale-105 rounded-3xl relative -z-10' src="/static/Gaming-Data-Infrastructure.png" alt="" />
    
  </div>
    <span className='!text-[25px] !font-bold py-6'>Instant Root Cause Analysis</span>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        <RootCauseAnalysisCard
          icon={<img src='static/analysis/globe.svg' />}
          title="Precise location"
          description="Exact coordinates & map zone identified"
        />
        <RootCauseAnalysisCard
          icon={<img src='static/analysis/value.svg' />}
          title="Value Validation"
          description="150 damage became 10,000 - multiplication error"
        />
        <RootCauseAnalysisCard
          icon={<img src='static/analysis/analytics.svg' />}
          title="Network Analysis"
          description="Client-server desync at tick 458291"
        />
        <RootCauseAnalysisCard
          icon={<img src='static/analysis/replay.svg' />}
          title="Action Replay"
          description="Last 30 seconds of player actions stored"
        />
      </div>
</div>

    </div>
  </section>
);
